import { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";
import { Button, Image, Tooltip } from "antd";
import uploadIcon from "../../../assets/images/NewDesign/upload.svg";

const MaintenanceListFields = (props) => {
  const shouldShow = shouldShowComponent(
    config.project,
    "MaintenanceListFields"
  );

  const storeContext = useContext(StoreContext);

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      <Button
        className="uploadExcelButton"
        onClick={() => { props.showUploadPopup() }}
      >
        <Tooltip
          title={storeContext.translate("_UPLOAD_")}
          placement="bottom"
        >
          <Image
            style={{
              height: 18,
            }}
            src={uploadIcon}
          />
        </Tooltip>
      </Button>
    </>
  );
};

MaintenanceListFields.contextType = StoreContext;
export default observer(withRouter(MaintenanceListFields));